import { createSlice } from '@reduxjs/toolkit';

export const utilSlice = createSlice({
	name: 'header',
	initialState: {
		update: false, // Trigger to update a component instead of "useNavigate"
		tempData: undefined, // Store temp data to share between components
		currentAudioDevice: undefined, // Store current audio device
	},
	reducers: {
		setUpdate: (state, action) => {
			state.update = action.payload.update;
		},
		setTempData: (state, action) => {
			state.tempData = action.payload.tempData;
		},
		setCurrentAudioDevice: (state, action) => {
			state.currentAudioDevice = action.payload;
		},
	},
});

export const { setUpdate, setTempData, setCurrentAudioDevice } =
	utilSlice.actions;

export default utilSlice.reducer;
